import { EActionTypes } from '../../actions/myHome';
import { TReduxActions } from '../../types/redux';
import { EMyHomeRealtyListStatus, IMyHomeState } from '../../types/redux/myHome';

export const initialState: IMyHomeState = {
  realtyList: {
    status: EMyHomeRealtyListStatus.init,
  },
};

export const myHomeReducer = (state = initialState, action: TReduxActions): IMyHomeState => {
  if (action.type === EActionTypes.SetRealtyList) {
    return {
      ...state,
      realtyList: {
        ...state.realtyList,
        data: action.payload,
        status: EMyHomeRealtyListStatus.succeed,
      },
    };
  }

  return state;
};
